import http from "../utils/http-common";

class CustomerTypesDataService {
  getAll() {
    return http.get("/customer-types");
  }

  get(id) {
    return http.get(`/customer-types/${id}`);
  }

  create(data) {
    return http.post("/customer-types", data);
  }

  update(id, data) {
    return http.put(`/customer-types/${id}`, data);
  }

  delete(id) {
    return http.delete(`/customer-types/${id}`);
  }
}

export default new CustomerTypesDataService();